module.exports = __webpack_public_path__ + "img/konfigurator-tooltip-spiegel-02.73b40109.jpg";